import React, { useState, useEffect, useCallback } from "react";
import { Button } from "./ui/button";
import { Download, X } from "lucide-react";

export function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  const handleBeforeInstallPrompt = useCallback((e) => {
    e.preventDefault();
    // Only show on mobile
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Check if already dismissed this session
    if (sessionStorage.getItem("pwa-dismissed")) return;

    // Check if already installed (standalone mode)
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    setDeferredPrompt(e);
    setShowPrompt(true);
  }, []);

  useEffect(() => {
    // Don't show if running as installed app
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, [handleBeforeInstallPrompt]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    setDeferredPrompt(null);
    sessionStorage.setItem("pwa-dismissed", "true");
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 md:hidden" data-testid="pwa-install-prompt">
      <div className="bg-white border border-slate-200 rounded-lg shadow-lg p-4 flex items-center gap-3">
        <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-900">Install CIS App</p>
          <p className="text-xs text-slate-500">Quick access from your home screen</p>
        </div>
        <Button size="sm" className="btn-primary flex-shrink-0" onClick={handleInstall} data-testid="pwa-install-btn">
          Install
        </Button>
        <button onClick={handleDismiss} className="p-1 hover:bg-slate-100 rounded flex-shrink-0" data-testid="pwa-dismiss-btn">
          <X className="w-4 h-4 text-slate-400" />
        </button>
      </div>
    </div>
  );
}
